import { atom } from 'jotai';
import type { ResolvedAnswer } from '../../../contracts/ask-user-details.types';

/** Per-question answers stashed before a mixed / multi-text wait can POST. */
export type ClarificationAnswerDraft = Record<string, ResolvedAnswer | null>;

/** Drafts keyed by harness ``approvalId``. Cleared on resolve, deny, or gone. */
export type ClarificationAnswerDrafts = Record<string, ClarificationAnswerDraft>;

/**
 * In-memory merge buffer for one ``ask_user`` wait whose answers arrive on
 * two channels: composer (folded ``kind=text``) and the structured card.
 * Not persisted — a reload drops the draft and the wait stays open.
 */
export const clarificationAnswerDraftAtom = atom<ClarificationAnswerDrafts>({});
